import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

interface IServiceCard {
  /** First line — rendered in the brand gradient. */
  line1: string;
  /** Second line — rendered in white. */
  line2: string;
  /** Background photo under public/images/landing/services-grid/. */
  image: string;
  /** Router destination. */
  link: string;
}

@Component({
  selector: 'app-services',
  imports: [RouterLink],
  templateUrl: './services.html',
  styleUrl: './services.scss'
})
export class Services {
  /** 5×2 grid of service cards. Order matches the design (left→right, top→bottom).
     Photos live in public/images/landing/services-grid/<file>; drop the 10 images there. */
  protected readonly cards: IServiceCard[] = [
    { line1: 'mobile app',     line2: 'development',  image: 'mobile-app-development.avif',     link: '/app-development-company' },
    { line1: 'ai app',         line2: 'development',  image: 'ai-app-development.avif',         link: '/ai-app-development-company' },
    { line1: 'app store',      line2: 'optimization', image: 'app-store-optimization.avif',     link: '/mobile-app-marketing-services' },
    { line1: 'mobile app',     line2: 'marketing',    image: 'mobile-app-marketing.avif',       link: '/mobile-app-marketing-services' },
    { line1: 'user',           line2: 'acquisition',  image: 'user-acquisition.avif',           link: '/mobile-app-marketing-services' },
    { line1: 'answer engine',  line2: 'optimization', image: 'answer-engine-optimization.avif', link: '/aeo-marketing-services' },
    { line1: 'influencer',     line2: 'marketing',    image: 'influencer-marketing.avif',       link: '/influencer-process' },
    { line1: 'website',        line2: 'marketing',    image: 'website-marketing.avif',          link: '/website-marketing-services' },
    { line1: 'conversion',     line2: 'optimization', image: 'conversion-optimization.avif',    link: '/website-marketing-services' },
    { line1: 'growth',         line2: 'strategy',     image: 'growth-strategy.avif',            link: '/business-mobile-consulting' },
  ];
}
